import styled from 'styled-components';

export const Wrapper = styled.div<{ $variant?: 'default' | 'chat' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  border-radius: var(--t-button-border-radius, 20px);
  background-color: var(--t-brand-bg-color, #ffffff);
  border: 1px solid var(--t-horizontal-vertical-rule, #707070);
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: var(--t-brand-alt-color, #f4f4f4);
    border-color: var(--t-brand-fg-color, #1c1c1c);
  }

  &:focus-visible {
    outline: 2px solid var(--t-brand-fg-color, #1c1c1c);
    outline-offset: 2px;
  }

  &:active {
    background-color: var(--t-brand-fg-color, #1c1c1c);

    * {
      color: var(--t-brand-bg-color, #ffffff);
    }
  }

  ${props =>
    props.$variant === 'chat' &&
    `
    height: 32px;
    padding: 0 16px;
    background-color: var(--colors-neutral-10, #f4f4f4);
    border: 1px solid var(--colors-neutral-20, #eeeeee);
    border-radius: 99px;
    transition: all 0.2s ease;

    &:hover {
      background-color: var(--colors-neutral-20, #eeeeee);
      border-color: var(--colors-neutral-30, #d6d6d6);
    }

    &:focus {
      outline: 2px solid var(--t-brand-fg-color, #1c1c1c);
      outline-offset: 2px;
    }

    &:active {
      transform: scale(0.98);
      background-color: var(--colors-neutral-20, #eeeeee);

      * {
        color: var(--t-brand-fg-color, #1c1c1c);
      }
    }
  `}
`;
